<i18n src="@/locales/modules/AlarmTranslate.json"></i18n>
<template>
	<div class="data-list-container alarms-mess-list">
		<!-- <div slot="header" class="flex flex-grow justify-end mb-10">
			<vs-input @input="mixinHandleSearch" size="large" class="input-search mr-3 md:block lg:block xl:block hidden" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />
		</div>
		<div @click="handleClickItemRow(alarm)" :class="['alarm-item mb-5 cursor-pointer', { 'alarm-received': alarm.is_received }]" v-for="alarm in alarms" :key="`alarmsg${alarm.id}`">
			<h5 class="text-black">{{ alarm.title }}</h5>
			<p class="text-base">{{ alarm.desc }}</p>
		</div> -->
		<vs-table ref="table" class="stack-table" :sst="true" :data="alarms" :max-items="limit" :noDataText="$t('Notify.NoDataAvailable')" @sort="mixinHandleSort">
			<div slot="header" class="flex flex-grow justify-end">
				<vs-input @input="mixinHandleSearch" size="large" class="input-search md:block lg:block xl:block hidden" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />
			</div>
			<template slot-scope="{ data }">
				<tbody>
					<vs-tr :class="['alarm-item cursor-pointer', { 'alarm-not-received': !tr.is_received }]" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<div @click="handleClickItemRow(tr)" class="py-4 px-6">
							<div class="grid grid-cols-4 gap-4">
								<p class="text-black font-bold col-span-3 ">{{ tr.title }}</p>
								<p class="text-right">{{ tr.created_at | dateTime(userDateTimeFormat) }}</p>
							</div>
							<p class="text-base text-black" v-html="tr.desc"></p>
						</div>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<CbsPagination class="mt-3" :total="totalPages" v-model="page" />
		<AlarmDetailDialog
			v-if="isDetailAlarmDialogActive"
			:data="detailAlarmDialogData"
			:isSidebarActive="isDetailAlarmDialogActive"
			@closeSidebar="toggleAlarmDetailSidebar"
			@onClickReceived="showReceivedConfirm"
		/>
	</div>
</template>

<script>
import moduleAlarm from "@/store/alarm/moduleAlarm";
import { withBasicQueries, productPermissions, getUserPermissions } from "@/mixins/mixins.js";
import AlarmDetailDialog from "./AlarmDetailDialog.vue";
export default {
	name: "AlarmsSetting",
	components: {
		AlarmDetailDialog
	},
	mixins: [
		withBasicQueries,
		getUserPermissions({
			...productPermissions
		})
	],
	computed: {
		alarms() {
			return this.$store.state.alarmManagement.alarms;
		},
		totalPages() {
			return Math.ceil(this.$store.state.alarmManagement.totalAlarms / this.limit);
		}
	},
	data() {
		return {
			page: 1,
			limit: 10,
			searchText: "",
			detailAlarmDialogData: {},
			isDetailAlarmDialogActive: false,
			productDialogData: {},
			isAlarmFormDialogActive: false
		};
	},
	watch: {
		page() {
			this.getAlarms();
		},
		"$route.query"() {
			this.getAlarms();
		},
		"$route.query.id"(newVal, oldVal) {
			if (Number(newVal) !== Number(oldVal) && this.$route.query.id) {
				this.viewDetail(this.$route.query.id);
			}
		}
	},
	methods: {
		async getAlarms() {
			this.$vs.loading();
			await this.$store.dispatch("alarmManagement/fetchAlarms", {
				page: this.page,
				search: this.searchText.trim(),
				limit: this.limit
			});
			this.$vs.loading.close();
		},

		handleClickItemRow(alarm) {
			this.detailAlarmDialogData = alarm;
			this.toggleAlarmDetailSidebar(true);
		},
		toggleAlarmDetailSidebar(val) {
			if (!val) {
				const routeQuery = this.$route.query || {};
				if (routeQuery.id) {
					this.$router.replace({ query: {} });
				}
			}
			this.isDetailAlarmDialogActive = val ? val : false;
		},

		async handleReceived(prod) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("alarmManagement/receivedAlarmsg", {
					id: prod.id
				});
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("ReceivedAlarmSuccessful")
					}
				});
				if (this.isDetailAlarmDialogActive) {
					this.toggleAlarmDetailSidebar(false);
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		showReceivedConfirm(prod) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("ConfirmReceived"),
				accept: () => this.handleReceived(prod),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async viewDetail(id) {
			try {
				this.$vs.loading();
				const alarmsg = await this.$store.dispatch("alarmManagement/getAlarmsgItem", id);
				this.handleClickItemRow(alarmsg);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		}
	},
	created() {
		this.$store.registerModule("alarmManagement", moduleAlarm);
		this.getAlarms();
		if (this.$route.query.id) {
			this.viewDetail(this.$route.query.id);
		}
	},
	beforeDestroy() {
		this.$store.unregisterModule("alarmManagement");
	}
};
</script>

<style lang="scss">
.alarm-item {
	padding: 16px 24px;
	&.alarm-not-received {
		background-color: #f2faff !important;
	}
}

.alarms-mess-list {
	.header-table {
		margin-bottom: 2rem;
	}
}
</style>
